import { Component, Input } from '@angular/core';
import { NgClass, NgIf } from "@angular/common";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
    imports: [
        NgClass,
        NgIf
    ],
  standalone: true
})
export class LoaderComponent {
    @Input() public fade: boolean = false;
    @Input() public loaderText: string;
    @Input() public size: 'md' | 'lg' = 'lg';
    @Input() public tableMode: boolean = false;

    constructor() { }

}
